import React, { useState, useEffect } from "react";
import SEO from "../components/SEO";

const keynoteLectures = [
  {
    id: 1,
    name: " Abhishek Kumar SRIVASTAVA",
    affiliation:
      "The Hong Kong University of Science and Technology, Hong Kong",
    image: "/nclc-2026/assets/abhishek-kumar-sRIVASTAVA.webp",
    biography:
      " Abhishek Kumar Srivastava is an Associate Professor and Associate Director of the Centre for Display Research at the Hong Kong University of Science and Technology. He received his Ph.D. degree in 2009 from the University of Lucknow, India. He is a Fellow of the Society for Information Display (SID), United States, and a member of IEEE, SPIE, and ILCS. He is the Editor-in-Chief of the Journal of the Society for Information Displays. His current research interests include photo-alignment technology, nanomaterials, and fast liquid crystals for advanced displays and photonic devices. In 2014, he received the ILCS Early-Career Award: The Michi Nakata Prize for his early-career efforts in ferroelectric liquid crystals and photoalignment. In 2018, he received the Best I-Zone display prototype of the Year Award at SID Display Week for ferroelectric liquid crystal displays. In the same year, he received the LG Bronze award from the Korean Information Display Society for the newly developed quantum rod enhancement film. He has published 260 research papers and holds 50 patents/patent applications. ",
    link: "https://eeabhishek.people.ust.hk/",
  },
  {
    id: 2,
    name: "Ralf Stannarius",
    affiliation: "Otto von Guericke University, Magdeburg, Germany",
    image: "/nclc-2026/assets/ralf-stannarius.webp",
    biography: ``,
    link: "https://www.aks.ovgu.de/aks/en/The+Group/Staff/Ralf+Stannarius.html, http://www.stannarius.de/",
  },
  {
    id: 3,
    name: "Young ki Kim",
    affiliation:
      "Department of Chemical Engineering, Pohang University of Science and Technology (POSTECH), Pohang 37673, Republic of Korea",
    image: "/nclc-2026/assets/young-ki-kim.webp",
    biography: `Young-Ki Kim is currently Associate Professor in the Department of Chemical Engineering at Pohang University of Science and Technology (POSTECH), Republic of Korea.  He received BSc degree in Physics at Korea University (2007) and MSE at Hanyang University (2009), Korea.  He then received his PhD (2015) in Chemical Physics from Liquid Crystal Institute at Kent State University under the supervision of Prof. Oleg D. Lavrentovich.  Prior to joining POSTECH, he had worked as a postdoctoral associate in the laboratory of Prof. Nicholas L. Abbott in the Department of Chemical Engineering at University of Wisconsin-Madison (2015–2018) and Cornell University (2018–2019).  His research focuses on the design of multifunctional materials using liquid crystallinity for a variety of applications including drug delivery systems, chemical/bio sensors, micro-robot, and optoelectronic devices.  Prof. Kim has published over 70 papers in peer-reviewed journals including Nature, Science, Advanced Materials, Nature Communications, and Physical Review Letters.`,
    link: "",
  },
 
];

const SpeakerModal = ({ speaker, onClose }) => {
  useEffect(() => {
    if (speaker) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [speaker]);
  if (!speaker) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-2xl animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative p-6 md:p-8">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-2xl font-bold text-gray-500 hover:text-red-500"
          >
            ×
          </button>

          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/3">
              <img
                src={speaker.image}
                alt={speaker.name}
                className="w-full rounded-xl shadow-lg object-cover"
              />
            </div>

            <div className="md:w-2/3">
              <h2 className="text-3xl font-bold text-[#1e1b4b] mb-2">
                {speaker.name}
              </h2>

              <p className="text-indigo-600 font-semibold mb-6">
                {speaker.affiliation}
              </p>

              <div className="border-t pt-4">
                <h3 className="text-lg font-semibold mb-3 text-gray-800">
                  Biography
                </h3>

                <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {speaker.biography}
                </p>
                {speaker.link && (
                  <a
                    href={speaker.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Visit Profile : {speaker.link}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const KeynoteSpeakers = () => {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  return (
    <>
      <SEO
        title="Keynote Speakers"
        description="Meet the keynote speakers and experts participating in the conference."
      />

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 0.25s ease-out forwards;
        }
      `}</style>

      <div className="min-h-screen bg-[#f8f9fa] py-16 pt-28 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl uppercase font-bold text-center text-[#1e1b4b] mb-16 tracking-wide">
            Keynote Speakers
          </h1>

          <div className="flex items-center mb-10">
            <h2 className="text-2xl font-bold text-[#1e1b4b] bg-white px-6 py-3 rounded-lg shadow-sm border-l-4 border-indigo-600">
              Keynote Speakers
            </h2>

            <div className="flex-grow h-px bg-gray-200 ml-6"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {keynoteLectures.map((speaker) => (
              <div
                key={speaker.id}
                onClick={() => setSelectedSpeaker(speaker)}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col items-center text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group"
              >
                <div className="relative w-full mb-4">
                  <div className="w-full aspect-square rounded-xl overflow-hidden border-2 border-indigo-50 group-hover:border-indigo-200 transition-colors">
                    <img
                      src={speaker.image}
                      alt={speaker.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>

                  <div className="absolute top-2 right-2 bg-indigo-600 text-white text-xs font-bold w-7 h-7 rounded-full flex items-center justify-center">
                    {speaker.id}
                  </div>

                  <div className="absolute inset-0 rounded-xl bg-indigo-600/0 group-hover:bg-indigo-600/10 flex items-center justify-center transition-all duration-300">
                    <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-white text-indigo-700 text-xs font-semibold px-3 py-1.5 rounded-full shadow">
                      View Profile
                    </span>
                  </div>
                </div>

                <h3 className="text-base font-bold text-gray-900 leading-tight mb-2">
                  {speaker.name}
                </h3>

                <p className="text-xs text-gray-500 font-medium">
                  {speaker.affiliation}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <SpeakerModal
        speaker={selectedSpeaker}
        onClose={() => setSelectedSpeaker(null)}
      />
    </>
  );
};

export default KeynoteSpeakers;

